<div class="card-container" [style.backgroundColor]="lessonCardInfo.color">
  <div class="card-format" [style.height.px]="cardSizeScaled">
    <div class="card-content-container" fxLayout="column" [style.transform]="scaleCard" (click)="goToInfo()">
      
      
      <div class="card-title80" [matTooltip]="lessonCardInfo.name" *ngIf="cardSize<80">
        <div>{{ lessonCardInfo.name }}</div>
      </div>
      <div class="card-title" [matTooltip]="lessonCardInfo.name"*ngIf="cardSize>80">
        <div>{{ lessonCardInfo.name }}</div>
      </div>
      <div fxFlex *ngIf="cardSize>80"></div>
      <div class="card-category-description" *ngIf="cardSize>80">
        <a>
          <div>{{ lessonCardInfo.description }}</div>
        </a>
      </div>
      <div fxFlex *ngIf="cardSize>80"></div>
     <!--  <mat-chip-list class="card-tag-container">
        <mat-chip class="card-tag" *ngFor="let tag of lessonCardInfo.tags" [style.color]="lessonCardInfo.color">
          {{ tag }}
        </mat-chip>
      </mat-chip-list> -->
      <div class="card-category" *ngIf="cardSize>80">{{ lessonCardInfo.category }}</div>
      <div fxFlex *ngIf="cardSize>80"></div>
      <!-- <div class="card-scene" fxLayout="row" fxLayoutAlign="left center" fxLayoutGap="1em">
        <!-- <div>
          <mat-icon>text_snippet</mat-icon>
        </div>
        <div>
          <mat-spinner diameter="20" color="primary" *ngIf="!(actCount >= 0)"></mat-spinner>
          {{actCount}}
        </div> 
      </div> -->
      <div class="card-date2"*ngIf="cardSize<80">{{ lessonCardInfo.owner.name}}</div>
      <div class="card-date"*ngIf="cardSize>240">{{ lessonCardInfo.owner.name}}</div>
    </div>


    <div fxFlex></div>
    <div class="buttons-container" fxLayout="column" fxLayoutGap="10px" [style.transform]="scaleCard">
      <div matRipple matRippleCentered="true" matRippleUnbounded="true" class="card-button" >
        <mat-icon [matMenuTriggerFor]="menu">more_horiz</mat-icon>
        <mat-menu #menu="matMenu" [style.transform]="scaleCard">
          <button mat-menu-item (click)="onCourse()" class="card-menu"><small>{{'MENU_CARD.COURSES'|translate}}</small></button>
          <mat-divider></mat-divider>
          <a mat-menu-item [routerLink]="['/lessons/lesson-creator/', lessonCardInfo.id]" class="card-menu" *ngIf="canEdit"><small>{{'MENU_CARD.EDIT'|translate}}</small></a>
          <mat-divider *ngIf="canEdit && canDelete"></mat-divider>
          <button mat-menu-item (click)="onDelete()" class="card-menu" *ngIf="canDelete"><small>{{'MENU_CARD.DELETE'|translate}}</small></button>
          <mat-divider *ngIf="isInstalled"></mat-divider>
          <button mat-menu-item (click)="onUnsubscribe()" class="card-menu" *ngIf="isInstalled"><small>{{'MENU_CARD.SUBSCRIBE'|translate}}</small></button>
        </mat-menu>
      </div>
      <div fxFlex (click)="goToInfo()"></div>
      <!-- <div matRipple matRippleCentered="true" matRippleUnbounded="true" class="card-button">
        <mat-icon>smartphone</mat-icon>
      </div> -->
      <!--div matRipple matRippleCentered="true" matRippleUnbounded="true" class="card-button">
        <mat-icon (click)="onVisibility()" matTooltip="{{lessonCardInfo.isPublic ? 'Publica':'Privada'}}">
          {{lessonCardInfo.isPublic ? 'visibility':'visibility_off'}}
        </mat-icon>
      </div-->
    </div>
  </div>
</div>

